export default __webpack_public_path__ + "static/media/LogoTaskusaNotMargin.ea727641.png";